import produce from "immer";
import React, { FC, useState } from "react";
import { Accordion, Button, Card, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import {
  startCopyForm,
  startEditForm,
  startSaveTemplate,
} from "../../../actions/formListAction";
import { startEditRow } from "../../../actions/rowListAction";
import { Form } from "../../../models/formModel";
import { Row } from "../../../models/rowModel";
import { getRowsByFormId } from "../../../selectors/rowListSelector";
import RowElement from "../../elementComponents/RowElement";
import Switch from "react-switch";
import {
  AlertPosition,
  AlertTransition,
  AlertType,
  defaultImg,
} from "../../../utils/constants";
import {
  Slide,
  Bounce,
  Zoom,
  Flip,
  toast,
  ToastPosition,
  ToastTransition,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Redirect, useHistory } from "react-router-dom";
import templateService from "../../../services/templateService";
import { Template } from "../../../models/templateModel";
import { getAllRowsAndSectionsAndElementsByFormId } from "../../../selectors/appSelectors";
import { transitions } from "react-alert";
import { useAuth } from "../../../contexts/authContext";
import "./formProperties.scss";
import { VscSaveAs, VscSaveAll } from "react-icons/vsc";
import { Tooltip } from "react-tippy";
import { SketchPicker } from "react-color";
import { IoColorPalette } from "react-icons/io5";
import ImageUploading, { ImageListType } from "react-images-uploading";
import chamalCasingCss from "../common/commonPropertyUtil/chamalCasingCss";
import { cssStyle } from "../../../models/cssStyleModel";
import { ImageModel } from "../../../models/imageModel";
import imageService from "../../../services/imageService";

export interface FormPropertiesProps {
  form: Form;
}

toast.configure();
const FormProperties: FC<FormPropertiesProps> = ({ form }) => {
  const dispatch = useDispatch();
  const [colorPicker, setColorPicker] = useState(false);
  const [images, setImages] = React.useState([]);
  const history = useHistory();
  // const formState = useSelector((state: AppState) => state.formList);
  const rowList = useSelector(getRowsByFormId(form?.id));
  const { authData } = useAuth();
  const [checked, setChecked] = useState(false);

  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newForm = produce(form, (draft) => {
      draft.cssStyles.push(newCssStyle);
    });
    dispatch(startEditForm(newForm));
  };

  const removeCssStyle = (index: number) => {
    const newForm = produce(form, (draft) => {
      draft.cssStyles.splice(index, 1);
    });
    dispatch(startEditForm(newForm));
  };

  const removeImg = () => {
    // const newElement = produce(element, draft => { draft.properties.imageUrl = defaultImg})
    // dispatch(startEditElement(newElement));
  };
  const onChange = async (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined
  ) => {
    console.log(imageList, addUpdateIndex);
    let img_type = imageList[0].file?.type.split("/")[1].toLowerCase();
    let imgString = imageList[0].data_url.split("base64,")[1];
    setImages(imageList as never[]);
    let imageUploadModel: ImageModel = {
      image: imgString,
      imageType: `${img_type}`,
    };
    const { data } = await imageService.saveImage({ image: imageUploadModel });

    const checkStyle = form.cssStyles.filter((css) => {
      return css.retrivedStyle === "background-image";
    })[0];
    let newCssStyle: cssStyle;
    if (checkStyle) {
      newCssStyle = produce(checkStyle, (draft) => {
        draft.value = `url("${data.data}")`;
      });
    } else {
      newCssStyle = {
        id: uuid(),
        style: "Background-Image",
        retrivedStyle: "background-image",
        value: `url("${data.data}")`,
      };
    }
    const newForm = produce(form, (draft) => {
      draft.cssStyles.push(newCssStyle);
    });
    dispatch(startEditForm(newForm));
  };

  const handleChange = (nextChecked: boolean) => {
    setChecked(nextChecked);
    const newModal = produce(form, (draft) => {
      draft.modalAttribute.modalLarge = nextChecked;
    });
    dispatch(startEditForm(newModal));
  };

  const handleChangeCenteredModel = (nextChecked: boolean) => {
    setChecked(nextChecked);
    const newModal = produce(form, (draft) => {
      draft.modalAttribute.modelCentered = nextChecked;
    });
    dispatch(startEditForm(newModal));
  };

  const handleMargineChange = (nextChecked: boolean, row: Row) => {
    setChecked(nextChecked);
    const newRowElement = produce(row, (draft) => {
      draft.rowHighlight = nextChecked;
    });
    dispatch(startEditRow(newRowElement));
  };

  //modal show & hide hooks -- start
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //modal show & hide hooks -- end

  const editRowHighlight = (row: Row) => {
    const newRowElement = produce(row, (draft) => {
      draft.rowHighlight = !draft.rowHighlight;
    });
    dispatch(startEditRow(newRowElement));
  };
  const editFormName = (e: React.ChangeEvent<HTMLInputElement>, form: Form) => {
    const newForm = produce(form, (draft) => {
      draft.name = e.target.value;
    });
    dispatch(startEditForm(newForm));
  };

  const previewForm = (form: Form) => {
    let path = `/preview/${form.id}`;
    history.push(path);
  };

  const copyFormOrModalAction = (type: string, saveAs: string) => {
    // dispatch(startCopyForm({name:`Test Copy ${type}`, projectId:form.projectId, type:type, modalAttribute:{"title":"","modalLarge":false,"modelCentered":false},alertAttribute:{"message":"","displayTime":"","notificationType":"","position":""}}))
    const createdBy = authData ? authData.userName : "";
    dispatch(startCopyForm(form.id, createdBy, saveAs));
    // dispatch(startSaveTemplate());
  };

  //custome css - start
  const styleObj: { [key: string]: any } = {};
  if(form) {
    for (let index = 0; index < form.cssStyles.length; index++) {
      styleObj[form.cssStyles[index].retrivedStyle] = form.cssStyles[index].value;
    }
  }    
  //custome css - end

  const renderRowList = () => {
    return rowList.map((row, i) => {
      let Rowid = uuid();
      let propId = uuid();
      let propertyId = "#" + propId;
      return (
        <div className="border-bottom box theam-btn">
          <div className="form-group row margin-bottom-auto width-359">
            <label className="col-sm-12 col-form-label align-text-left">
              Row Properties {i + 1}
            </label>
          </div>
          <div className="form-group row align-items-center margin-bottom-auto width-359">
            <label
              htmlFor="section-size"
              className="col-sm-4 align-text-left font-size-12"
            >
              Border
            </label>
            <div className="col-sm-8 remove-left-right-padding">
              <Switch
                checked={row.rowHighlight}
                onChange={() => {
                  editRowHighlight(row);
                }}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={10}
                width={24}
                className="react-switch"
                id="material-switch-margine"
              />
            </div>
          </div>
        </div>
        // <div className="card">
        //   <div id={Rowid}>
        //     <h5 className="mb-0">
        //       <button
        //         className="btn btn-link collapsed"
        //         data-toggle="collapse"
        //         data-target={propertyId}
        //         aria-expanded="false"
        //         aria-controls={propId}
        //       >
        //         Row Properties {i + 1}
        //       </button>
        //     </h5>
        //   </div>
        //   <div id={propId} className="collapse show" aria-labelledby={Rowid}>
        //     <div className="card-body">

        //     </div>
        //   </div>
        // </div>
      );
    });
  };

  const transitionAlert = () => {
    switch (form.alertAttribute.alertTransition) {
      case "Slide":
        return Slide;
      case "Zoom":
        return Zoom;
      case "Flip":
        return Flip;
      case "Bounce":
        return Bounce;
      default:
        return undefined;
    }
  };
  //preview modal
  const renderRowListModal = () => {
    let rowListBySelectedFrom = rowList.filter((row) => {
      if (row.type === "form" && row.formId === form.id) return row;
    });
    return rowListBySelectedFrom.map((row, i) => {
      return <RowElement row={row} index={i} isPreview={true} />;
    });
  };

  const previewAlert = () => {
    switch (form.alertAttribute.notificationType) {
      case "Alert-Info":
        return toast.info(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      case "Alert-Success":
        return toast.success(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      case "Alert-Warning":
        return toast.warning(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      case "Alert-Error":
        return toast.error(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      case "Alert-Default":
        return toast(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      case "Alert-Dark":
        return toast.dark(form.alertAttribute.message, {
          position: form.alertAttribute.position,
          autoClose: form.alertAttribute.displayTime * 1000,
          transition: transitionAlert(),
        });
      default:
        return null;
    }
  };
  return (
    <div className=" padding-0">
      {form?.type === "form" && (
        <>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="form-name"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Form Name
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control theam-textbox"
                id="form-name"
                value={form.name}
                onChange={(e) => {
                  editFormName(e, form);
                }}
              />
            </div>
          </div>
          {/* <div className="form-group row">
            <label
              htmlFor="form-color"
              className="col-sm-4 col-form-label font-size-12 lbl-align-right"
            >
              Color
            </label>
            <div className="col-sm-8">
              {colorPicker && (
                <SketchPicker
                // color={element.styles.color}
                // onChange={(color) => {
                //   const newElement = produce(element, (draft) => {
                //     draft.styles.color = color.hex;
                //   });
                //   dispatch(startEditElement(newElement));
                // }}
                />
              )}
              <button
                className="btn btn-block"
                onClick={() => {
                  setColorPicker(!colorPicker);
                }}
              >
                <IoColorPalette size={25} />
              </button>
            </div>
          </div> */}

          {/* <div className="form-group col-12 m-2 p-2">
        <button
          type="button"
          className="btn btn-dark btn-sm font-size-12"
          onClick={addNewCssStyle}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>

      {form.cssStyles.map((_style: cssStyle, i: number) => {
        return (
          <div key={i}>
            <div className="form-group row">
              <div className="col-sm-10"></div>
              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-dark btn-sm font-size-12"
                  onClick={(e) => removeCssStyle(i)}
                >
                  <i className="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-5 noPadding">
                <input
                  type="text"
                  className="form-control"
                  id={`style${i}`}
                  value={_style.style}
                  placeholder="Css Property"
                  onChange={(e) => {
                    const newForm = produce(form, (draft) => {
                      draft.cssStyles[i].style = e.target.value;
                      draft.cssStyles[i].retrivedStyle = chamalCasingCss(e.target.value);
                    });
                    dispatch(startEditForm(newForm));
                  }}
                />
              </div>
              <div className="col-sm-1 noPadding">:</div>
              <div className="col-sm-6 noPadding">
                <input
                  type="text"
                  className="form-control"
                  id={`value${i}`}
                  value={_style.value}
                  placeholder="Enter Value"
                  onChange={(e) => {
                    const newForm = produce(form, (draft) => {
                      draft.cssStyles[i].value = e.target.value;
                    });
                    dispatch(startEditForm(newForm));
                  }}
                />
              </div>
            </div>
          </div>
        );
      })} */}
        </>
      )}
      {form?.type === "model" && (
        <>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="form-name"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Modal Name
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control theam-textbox"
                id="form-name"
                value={form.name}
                onChange={(e) => {
                  editFormName(e, form);
                }}
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="form-name"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Modal Title
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control theam-textbox"
                id="form-name"
                value={
                  form.modalAttribute.title === undefined
                    ? ""
                    : form.modalAttribute.title
                }
                onChange={(e) => {
                  const newModal = produce(form, (draft) => {
                    draft.modalAttribute.title = e.target.value;
                  });
                  dispatch(startEditForm(newModal));
                }}
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <div className="col-sm-4 col-form-label font-size-12 align-text-left">
              <label>Large modal</label>
            </div>
            <div className="col-sm-2">
              <Switch
                checked={form.modalAttribute.modalLarge}
                onChange={handleChange}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={10}
                width={24}
                className="react-switch"
                id="material-switch"
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <div className="col-sm-4 col-form-label font-size-12 align-text-left">
              <label>Centered</label>
            </div>
            <div className="col-sm-2">
              <Switch
                checked={form.modalAttribute.modelCentered}
                onChange={handleChangeCenteredModel}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={10}
                width={24}
                className="react-switch"
                id="material-switch-Centered"
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <div className="col">
              <button
                type="button"
                className="btn btn-orrange btn-sm btn-block"
                onClick={(e) => {
                  setShow(true);
                }}
              >
                Preview
              </button>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            size={form.modalAttribute.modalLarge ? "lg" : "xl"}
            centered={form.modalAttribute.modelCentered}
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ marginBottom:0 , marginTop:0}}>
               {form.modalAttribute.title}  
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container" style={{...styleObj}}>{renderRowListModal()}</div>
            </Modal.Body>
          </Modal>
        </>
      )}
      {(form?.type === "form" || form?.type === "model") && (
        <>
          <div className="form-group row margin-right-left-0">
            <div className="col-sm-4"></div>
            <div className="col-sm-2 ">
              <button
                type="button"
                className="btn-save theam-btn"
                onClick={(e) => {
                  copyFormOrModalAction(form.type, "template");
                }}
              >
                <Tooltip title="Save As Template">
                  <VscSaveAs size={25} />
                </Tooltip>
              </button>
            </div>
            <div className="col-sm-2">
              <button
                type="button"
                className="btn-save theam-btn"
                onClick={(e) => {
                  copyFormOrModalAction(form.type, "user");
                }}
              >
                <Tooltip title="Save As Copy">
                  <VscSaveAll size={25} />
                </Tooltip>
              </button>
            </div>
            {/* {form.type === 'form' && (
            <div className="col-sm-4">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                previewForm(form);
              }}
            >
              Preview
            </button>
          </div>
          )} */}
          </div>
          <Accordion defaultActiveKey="0">
            <Card className="theam-component">
              <Accordion.Toggle
                as={Button}
                variant="outline-dark"
                className="theam-font"
                eventKey="0"
              >
                Advance Css
                  <button
                      type="button"
                      className="btn btn-dark btn-sm font-size-12 f-righit"
                      onClick={(e)=>{
                        e.stopPropagation();
                        addNewCssStyle()}}
                    >
                   <Tooltip title="Add Css">
                      <i className="fa fa-plus"></i>
                  </Tooltip>
                    </button>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body className=" widh-a">
                  {form.cssStyles.map((_style: cssStyle, i: number) => {
                    return (
                      <div key={i}>
                        <div className="form-group row">
                          <div className="col-sm-4 noPadding">
                            <input
                              type="text"
                              className="form-control theam-textbox"
                              id={`style${i}`}
                              value={_style.style}
                              placeholder="Css Property"
                              onChange={(e) => {
                                const newForm = produce(form, (draft) => {
                                  draft.cssStyles[i].style = e.target.value;
                                  draft.cssStyles[i].retrivedStyle =
                                    chamalCasingCss(e.target.value);
                                });
                                dispatch(startEditForm(newForm));
                              }}
                            />
                          </div>
                          <div className="col-sm-1 noPadding">:</div>
                          <div className="col-sm-5 noPadding">
                            <input
                              type="text"
                              className="form-control theam-textbox"
                              id={`value${i}`}
                              value={_style.value}
                              placeholder="Enter Value"
                              onChange={(e) => {
                                const newForm = produce(form, (draft) => {
                                  draft.cssStyles[i].value = e.target.value;
                                });
                                dispatch(startEditForm(newForm));
                              }}
                            />
                          </div>
                          <div className="col-sm-2 noPadding">
                          <button
                              type="button"
                              className="btn btn-dark btn-sm font-size-12"
                              onClick={(e) => removeCssStyle(i)}
                            >
                              <Tooltip title="Remove css">
                                <i className="fa fa-minus"></i>
                              </Tooltip>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <Accordion defaultActiveKey="0">
            <Card className="theam-component">
              <Accordion.Toggle
                as={Button}
                variant="outline-dark"
                className="theam-font"
                eventKey="0"
              >
                Rows
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body className="padding-0 widh-a">
                  {renderRowList()}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </>
      )}
      {form?.type === "alert" && (
        <>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="form-name"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Alert Name
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control theam-textbox"
                id="form-name"
                value={form.name}
                onChange={(e) => {
                  editFormName(e, form);
                }}
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="alert-message"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Message
            </label>
            <div className="col-sm-8">
              <textarea
                className="form-control theam-textbox font-size-12"
                name="alert-message"
                id="alert-message"
                placeholder="Enter Alert Message"
                cols={30}
                rows={10}
                value={form.alertAttribute.message}
                onChange={(e) => {
                  const newAlert = produce(form, (draft) => {
                    draft.alertAttribute.message = e.target.value;
                  });
                  dispatch(startEditForm(newAlert));
                }}
              ></textarea>
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="alert-type"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Type
            </label>
            <div className="col-sm-8">
              <select
                value={form.alertAttribute.notificationType}
                id="alert-type"
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newAlert = produce(form, (draft) => {
                    draft.alertAttribute.notificationType = e.target.value;
                  });
                  dispatch(startEditForm(newAlert));
                }}
              >
                {AlertType.map((item, i) => {
                  return (
                    <option key={i} value={item.name} className={item.color}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="alert-position"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Posiion
            </label>
            <div className="col-sm-8">
              <select
                value={form.alertAttribute.position}
                id="alert-position"
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newAlert = produce(form, (draft) => {
                    draft.alertAttribute.position = e.target
                      .value as ToastPosition;
                  });
                  dispatch(startEditForm(newAlert));
                }}
              >
                {AlertPosition.map((item, i) => {
                  return (
                    <option key={i} value={item.value}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="alert-position"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Transition
            </label>
            <div className="col-sm-8">
              <select
                value={form.alertAttribute.alertTransition}
                id="alert-position"
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newAlert = produce(form, (draft) => {
                    draft.alertAttribute.alertTransition = e.target.value;
                  });
                  dispatch(startEditForm(newAlert));
                }}
              >
                {AlertTransition.map((item, i) => {
                  return (
                    <option key={i} value={item.value}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <label
              htmlFor="alert-delay"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Display time (sec)
            </label>
            <div className="col-sm-8">
              <input
                type="number"
                className="form-control theam-textbox"
                id="alert-delay"
                value={form.alertAttribute.displayTime}
                onChange={(e) => {
                  const newAlert = produce(form, (draft) => {
                    draft.alertAttribute.displayTime = parseInt(e.target.value);
                  });
                  dispatch(startEditForm(newAlert));
                }}
              />
            </div>
          </div>
          <div className="form-group row margin-right-left-0">
            <div className="col">
              <button
                type="button"
                className="btn btn-orrange btn-sm btn-block"
                onClick={(e) => {
                  {
                    previewAlert();
                  }
                }}
              >
                Preview
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FormProperties;
